function process (guards, from, to, RouterNext, i) {
  const guard = guards[i]
  // no middleware supplied
  if (guards.length === 0) {
    RouterNext()
    // last middleware
  } else if (guards.length === i + 1) {
    guard(from, to, RouterNext)
    // normal operation
  } else {
    guard(
      from,
      to,
      args => {
        if (typeof args === 'undefined') {
          process(guards, from, to, RouterNext, i + 1)
          return
        }

        RouterNext(args)
      }
    )
  }
}

export const multiBeforeEach = (to, from, next) => {
  const middlewares = to.matched
    .map(({ meta }) => meta.middleware)
    .flat()
    .filter(s => s)

  process(
    middlewares,
    from,
    to,
    next,
    0
  )
}

export default multiBeforeEach
